module.exports = __webpack_public_path__ + "static/sacoches2-a854ae63b5f77d2be835931f003514dc.jpg";